import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, SubscriptionLike } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CONFIG } from 'src/helper/app-config';
import { SKUModal } from 'src/modals/planogram';
import { PlanogramStateService } from 'src/services/planogram-state.service';
import { PlanogramService } from 'src/services/planogram.service';


interface DialogData{
  sku_id:number;
}

@Component({
  selector: 'app-sku-info-dialog',
  templateUrl: './sku-info-dialog.component.html',
  styleUrls: ['./sku-info-dialog.component.css']
})
export class SkuInfoDialogComponent implements OnInit, OnDestroy {

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData, private apiService: PlanogramService,
  private dialogRef: MatDialogRef<SkuInfoDialogComponent>, private planogramState: PlanogramStateService, private sanitizer: DomSanitizer) { }
  sas='?'+environment.sas
  
  ngOnInit(): void {
    this.dialogRef.afterClosed().subscribe(_res=>{
      this.planogramState.setSKUInfo({});
    })
    this.sku_list_subscription = this.sku_list_subscriber.subscribe(list=>{
      let selected_sku = list.find(l=> l.sku_id === this.data.sku_id);
      if(selected_sku){
        this.sku = selected_sku
        this.apiService.fetchImageFromBlob(this.sku.sku_img_link).subscribe((blob: Blob) => {
          // Update the specific SKU's image URL when loaded
          const imageUrl = URL.createObjectURL(blob);
          const safeUrl = this.sanitizer.bypassSecurityTrustUrl(imageUrl);
          this.sku.image_url = safeUrl as string;
        });
      }
    })
  }

  ngOnDestroy(): void {
    this.sku_list_subscription.unsubscribe()
  }

  CONFIG = CONFIG;
  sku_list_subscription: SubscriptionLike;
  sku_list_subscriber: Observable<SKUModal[]> = this.planogramState.available_skus;
  sku: SKUModal = {} as any;

  dialogClose(){
    this.dialogRef.close()
  }

}




